import { Fragment } from 'react'

import { type InlineHighlightSegment, parseInlineHighlights } from './inline-highlights'

const SEGMENT_CLASS: Record<Exclude<InlineHighlightSegment['kind'], 'text'>, string> = {
  bold: 'font-bold text-text-primary',
  primary: 'font-semibold text-primary-main',
}

/**
 * Copy with its `**bold**` and `==primary==` markers applied. Plain segments
 * stay bare text nodes, so copy with no markers renders exactly the DOM it
 * rendered before markers existed.
 *
 * Every announcement surface renders its body copy through this, so a marker
 * the operator types means the same thing on all of them. A marker never spans
 * a newline, so multi-line copy keeps its line breaks as typed.
 */
export const InlineHighlightedText = ({ text }: { text: string }) => (
  <>
    {parseInlineHighlights(text).map((segment, index) =>
      segment.kind === 'text' ? (
        // eslint-disable-next-line @eslint-react/no-array-index-key -- parsed once from fixed copy, never reordered; two plain segments can carry the same text
        <Fragment key={index}>{segment.text}</Fragment>
      ) : (
        <span
          // eslint-disable-next-line @eslint-react/no-array-index-key -- parsed once from fixed copy, never reordered; two highlights can carry the same text
          key={index}
          className={SEGMENT_CLASS[segment.kind]}
        >
          {segment.text}
        </span>
      ),
    )}
  </>
)
